import { ISupplierDataCheckDTO, ISupplierDataCheckViewDTO } from "../../libs/coreapi-dto/dirs/supplierDataCheck";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common/DictionaryDataProvider";


export class SupplierDataChecksDataProvider extends DictionaryDataProvider<ISupplierDataCheckViewDTO, ISupplierDataCheckDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ISupplierDataCheckViewDTO, ISupplierDataCheckDTO>> {
        return this._coreApiService.supplierDataCheckRequest
    }
}